import { Entity, EntityMap, EntityStatus, LoadingLifecycle } from './types';

export const getStatusForId: (entityMap: EntityMap<Entity>, id: string) => EntityStatus = (entityMap, id) => {
  const { pending, fulfilled, rejected } = entityMap;

  if (Object.prototype.hasOwnProperty.call(fulfilled.byId, id)) {
    return 'fulfilled';
  }

  if (Object.prototype.hasOwnProperty.call(rejected.byId, id)) {
    return 'rejected';
  }

  if (Object.prototype.hasOwnProperty.call(pending.byId, id)) {
    return 'pending';
  }

  return 'notRequested';
};

export const getStatus: <T>(loadingLifecycle: LoadingLifecycle<T>) => EntityStatus = (loadingLifecycle) => {
  if (loadingLifecycle.fulfilled !== undefined) {
    return 'fulfilled';
  }

  if (loadingLifecycle.rejected) {
    return 'rejected';
  }

  if (loadingLifecycle.pending) {
    return 'pending';
  }

  return 'notRequested';
};
